import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from "react-helmet-async";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Navbar from './components/navbar';
import HeroSection from './home/home';
import AboutSection from './home/about-section'; 
import TrustedBrandsSection from './home/brands'; 
import PricingSection from './home/pricing';
import Testimonials from './home/testimonials';
import FAQSection from './home/faq';
import ServicesSection from './pages/services';
import PortfolioSection from './pages/our-portfolio';
import CreativeShowcase from './sections/CreativeShowcase';
import AgencyAccSection from './pages/agency-acc';
import ContactUsSection from './pages/contact-us';
import ContactSection from './sections/ContactSection';
import Reviews from './pages/review'
import ReviewsForm from './sections/reviewsform'
import FeedbackSection from './sections/FeedbackSection';
import Footer from './components/footer';
import FloatingWhatsApp from './components/whatsapp_button';
import PrivacyPolicySection from "./legal/privacy_Policy";
import TermsSection from "./legal/Terms_of_Service";
import RefundPolicySection from "./legal/Refund_Policy";
import NotFound from "./components/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

const PageWrapper = ({ children, title, description, keywords }) => (
  <>
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
    {children}
  </>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<>
            <PageWrapper 
                title="RhythmGrowthLab | Smart Tech & Smart Marketing for Real Business Growth"
                description="Grow your business with RhythmGrowthlab. Expert website development, mobile apps, branding, SEO & performance marketing for scalable, high-converting growth."
                keywords="website development, mobile apps, branding, SEO, performance marketing, digital marketing, business growth, web design, app development, brand identity, online marketing, conversion optimization"
              >
                <Navbar />
                <HeroSection /> 
                <AboutSection />
                <TrustedBrandsSection />
                <PricingSection />
                <Testimonials />
                <FAQSection />
                <FeedbackSection />
                <Footer />
                <FloatingWhatsApp />
              </PageWrapper>
            </>} />
            <Route path="/services-and-pricing" element={<> 
            <PageWrapper
              title="RhythmGrowthLab - Services & Pricing"
              description="Explore our range of services and affordable pricing options designed to help your business grow."
              keywords="services, pricing, website development, mobile apps, branding, SEO, performance marketing"
            >
                <Navbar />
                <ServicesSection /> 
                <PricingSection />
                <FAQSection />
                <FeedbackSection />
                <Footer />
                <FloatingWhatsApp />
              </PageWrapper>
            </>} />
            <Route path="/agency-account" element={<>
            <PageWrapper
              title="RhythmGrowthLab - Agency Account"
              description="View Benefits of Meta Ads Agency Account, and Resources for your business growth."
              keywords="agency account, meta ads, business growth, digital marketing, advertising resources, marketing tools, online advertising, social media marketing, business resources"
            >
              <Navbar />
              <AgencyAccSection />
              <Footer />
              <FloatingWhatsApp />
            </PageWrapper>
            </>} />
            <Route path="/our-portfolio" element={<>
              <PageWrapper
                title="RhythmGrowthLab - Our Portfolio"
                description="Explore our latest projects and see how we've helped businesses like yours succeed."
                keywords="portfolio, projects, case studies, business success, digital marketing"
              >
                <Navbar />
                <PortfolioSection />
                <CreativeShowcase />
                <FeedbackSection />
                <Footer />
                <FloatingWhatsApp />
              </PageWrapper>
            </>} />
            <Route path="/contact-us" element={<> 
              <PageWrapper
                title="RhythmGrowthLab - Contact Us"
                description="Get in touch with us to discuss your project and how we can help your business grow."
                keywords="contact, get in touch, project discussion, business growth, digital marketing"
              >
                <Navbar />
                <ContactUsSection /> 
                <ContactSection />
                <Footer />
                <FloatingWhatsApp />
              </PageWrapper>
            </>} />
            <Route path="/please-leave-your-reviews" element={<> 
              <PageWrapper
                title="RhythmGrowthLab - Leave Your Reviews"
                description="We value your feedback! Please leave your reviews and help us improve our services."
                keywords="reviews, feedback, customer feedback, service improvement, testimonials"
              >
                <Navbar />
                <Reviews />
                <ReviewsForm />
                <Footer />
                <FloatingWhatsApp />
              </PageWrapper>
            </>} />
            <Route path="/privacy-policy" element={<> 
              <PageWrapper
                title="RhythmGrowthLab - Privacy Policy"
                description="Learn about our privacy practices and how we protect your personal information."
                keywords="privacy, policy, data protection, personal information"
              >
                <Navbar />
                <PrivacyPolicySection />
                <Footer />
                <FloatingWhatsApp />
              </PageWrapper>
            </>} />
            <Route path="/terms-of-service" element={<> 
              <PageWrapper
                title="RhythmGrowthLab - Terms of Service"
                description="Review our terms of service and understand your rights and responsibilities when using our services."
                keywords="terms, service, agreement, user rights, responsibilities"
              >
                <Navbar />
                <TermsSection />
                <Footer />
                <FloatingWhatsApp />
              </PageWrapper>
            </>} />
            <Route path="/refund-policy" element={<> 
              <PageWrapper
                title="RhythmGrowthLab - Refund Policy"
                description="Learn about our refund policies and procedures."
                keywords="refund, policy, returns, refunds"
              >
                <Navbar />
                <RefundPolicySection />
                <Footer />
                <FloatingWhatsApp />
              </PageWrapper>
            </>} />
            <Route path="*" element={<>
              <PageWrapper
                title="404 Not Found - RhythmGrowthLab"
              >
                <NotFound />
              </PageWrapper>
            </>} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  ) 
};

export default App;